import { Box, Popover } from '@mui/material';
import React, { ReactNode, useState } from 'react';

export interface IIconPopOverProps {
  element: React.ReactElement;
  title?: string;
  children: ReactNode;
  closePopOverOnClick?: boolean;
}

const WsElementWithPopOver: React.FC<IIconPopOverProps> = ({
  children,
  element,
  closePopOverOnClick = true,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>();
  const handlePopoverOpen = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event?.currentTarget);
  };
  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  return (
    <Box
      onMouseOver={(event) => handlePopoverOpen(event)}
      onMouseOut={handlePopoverClose}
      sx={{ cursor: 'pointer' }}
    >
      <Box aria-owns={open ? 'mouse-over-popover' : undefined} aria-haspopup="true">
        {element}
      </Box>
      <Popover
        id="mouse-over-popover"
        sx={{
          pointerEvents: 'none',
          m: 1,
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        disableRestoreFocus={true}
        onClick={() => closePopOverOnClick && handlePopoverClose()}
        onMouseLeave={handlePopoverClose}
        onMouseOut={handlePopoverClose}
        onKeyDown={(event) => event.key === 'Enter' && handlePopoverClose()}
      >
        <Box sx={{ pointerEvents: 'auto' }}>{children}</Box>
      </Popover>
    </Box>
  );
};

export default WsElementWithPopOver;
